import type { ITelephonyConfiguration } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { usePhoneNumberUserQuery } from '../../../queries/PhoneNumber/usePhoneNumberUserQuery';

export type TextIconState = 'ready' | 'noNumber' | 'hidden';

export type RepTextingNumber = {
	/** Drives the contact-row text icon. `hidden` while loading or when the account has no texting. */
	state: TextIconState;
	/** The rep's connected texting number, when they have one. */
	textingNumber: ITelephonyConfiguration | undefined;
};

/**
 * `GET PhoneNumber/user` already returns only the caller's Text-capable,
 * Connected numbers, so the first entry is the one to send from. The query is
 * skipped entirely when the account's texting feature is off.
 */
export function useRepTextingNumber(): RepTextingNumber {
	const userSession = useUserSession();
	const textingEnabled = userSession.account?.features?.texting?.enabled === true;
	const query = usePhoneNumberUserQuery({ enabled: textingEnabled });

	if (!textingEnabled || query.isPending) {
		return { state: 'hidden', textingNumber: undefined };
	}
	const textingNumber = query.data?.[0];
	return textingNumber ? { state: 'ready', textingNumber } : { state: 'noNumber', textingNumber: undefined };
}
